var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHouseChimney(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.5001 8.40018V3.50018C20.5001 3.22404 20.2762 3.00018 20.0001 3.00018H18.0001C17.7239 3.00018 17.5001 3.22404 17.5001 3.50018V5.64018L13.3381 1.81118C13.1466 1.63455 12.8516 1.63455 12.6601 1.81118L1.66007 12.1322C1.50822 12.2718 1.45775 12.4904 1.533 12.6825C1.60824 12.8746 1.79375 13.0008 2.00007 13.0002H4.50007V22.5002C4.50007 23.0525 4.94778 23.5002 5.50007 23.5002H20.5001C21.0524 23.5002 21.5001 23.0525 21.5001 22.5002V13.0002H24.0001C24.2062 13.0004 24.3913 12.8741 24.4663 12.6821C24.5413 12.4901 24.4908 12.2717 24.3391 12.1322L20.5001 8.40018Z",
    stroke: "#181B5E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHouseChimney);
export default __webpack_public_path__ + "static/media/house-chimney.d0141aaacfa1a802712a06bd0d97f089.svg";
export { ForwardRef as ReactComponent };